// extracted by mini-css-extract-plugin
export default {"select":"app-Imports-SpreadsheetPreview-module__pauxsuwJU8IXo3ncsDml","container":"app-Imports-SpreadsheetPreview-module__ZriaswKYHw2zTXIgJUEh"};